import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      d="M10.1899 14.7002V18.3002C10.1899 19.7914 11.3987 21.0002 12.8899 21.0002L16.4899 12.9002V3.00011H6.03188C5.13432 2.99008 4.36646 3.64276 4.23188 4.53023L2.98988 12.6302C2.91063 13.1524 3.06467 13.683 3.41121 14.0815C3.75774 14.48 4.2618 14.7062 4.78988 14.7002H10.1899Z"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.03571 2.25011H16.4899C16.9041 2.25011 17.2399 2.5859 17.2399 3.00011V12.9002C17.2399 13.0052 17.2179 13.1089 17.1752 13.2048L13.5752 21.3048C13.4549 21.5757 13.1863 21.7502 12.8899 21.7502C10.9845 21.7502 9.43988 20.2056 9.43988 18.3002V15.4502H4.7938C4.04736 15.4573 3.33518 15.137 2.84526 14.5736C2.35433 14.009 2.1361 13.2574 2.24838 12.5177L3.49036 4.41778C3.4904 4.41756 3.49033 4.418 3.49036 4.41778C3.68108 3.16236 4.76644 2.23816 6.03571 2.25011ZM6.0235 3.75007C5.49984 3.74422 5.05191 4.12501 4.97341 4.64268L3.73139 12.7428C3.73137 12.7429 3.73141 12.7426 3.73139 12.7428C3.68532 13.0472 3.77512 13.357 3.97716 13.5893C4.17931 13.8218 4.47335 13.9538 4.78139 13.9503L4.78988 13.9502L10.1899 13.9502C10.6041 13.9502 10.9399 14.286 10.9399 14.7002V18.3002C10.9399 19.2177 11.5735 19.9872 12.427 20.195L15.7399 12.7411V3.75011L6.0235 3.75007Z"
      fill="currentColor"
    />
    <path
      d="M16.4897 3.00033H18.8927C19.9471 2.98168 20.8484 3.75534 20.9897 4.80033V11.1003C20.8484 12.1453 19.9471 13.019 18.8927 13.0003H16.4897V3.00033Z"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2397 4.85642C20.1304 4.21104 19.565 3.73856 18.906 3.75021L18.8927 3.75045L17.2397 3.75033V12.2503H18.906C19.5182 12.2612 20.1235 11.7406 20.2397 11.0446V4.85642ZM18.8866 2.25033C20.3182 2.22857 21.541 3.28019 21.733 4.6998C21.7375 4.73312 21.7397 4.76671 21.7397 4.80033V11.1003C21.7397 11.134 21.7375 11.1675 21.733 11.2009C21.5477 12.5703 20.3667 13.7726 18.8867 13.7503H16.4897C16.0755 13.7503 15.7397 13.4145 15.7397 13.0003V3.00033C15.7397 2.58612 16.0755 2.25033 16.4897 2.25033H18.8866Z"
      fill="currentColor"
    />
  </svg>
);
